import React from 'react'
import Chip from '@mui/material/Chip'
import LeaderboardIcon from '@mui/icons-material/Leaderboard'
import { Tooltip, Zoom } from '@mui/material'

interface ComponentProps {
  kycTierLevel: string | undefined
}

export const KYCTierLevelChip: React.FC<ComponentProps> = ({ kycTierLevel }: ComponentProps) => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined
  let tierlevel: number | undefined

  if (kycTierLevel === 'TIER_LEVEL_0') {
    variant = 'outlined'
    tierlevel = 0
  } else if (kycTierLevel === 'TIER_LEVEL_1') {
    color = 'success'
    variant = 'outlined'
    tierlevel = 1
  } else if (kycTierLevel === 'TIER_LEVEL_3') {
    color = 'primary'
    variant = 'outlined'
    tierlevel = 3
  } else {
    variant = 'outlined'
  }

  return (
      <>
        { kycTierLevel === null || kycTierLevel === ''
          ? (
                <></>
            )
          : (
                <Tooltip title={tierlevel} TransitionComponent={Zoom} arrow placement='bottom'>
                  <Chip icon={<LeaderboardIcon/>} label={tierlevel} variant={variant} color={color}/>
                </Tooltip>
            )
        }
      </>
  )
}
